import { Dispatch, SetStateAction } from 'react';
import { useDateFromStringState } from '@msrceng/component';

/**
 * This is a shim that allows the date state in the app to use `Date` objects
 * while the storage state uses strings.
 */
export const useStringToDateStateShim = ({
  storageEndDate,
  storageStartDate,
  setStorageEndDate,
  setStorageStartDate,
}: {
  storageEndDate: string | undefined;
  storageStartDate: string | undefined;
  setStorageEndDate: Dispatch<SetStateAction<string | undefined>>;
  setStorageStartDate: Dispatch<SetStateAction<string | undefined>>;
}): {
  startDate: Date | undefined;
  setStartDate: (T: DateActionParam) => void;
  endDate: Date | undefined;
  setEndDate: (T: DateActionParam) => void;
} => {
  const [startDate, setStartDate] = useDateFromStringState(
    storageStartDate,
    setStorageStartDate
  );
  const [endDate, setEndDate] = useDateFromStringState(
    storageEndDate,
    setStorageEndDate
  );

  return {
    startDate,
    setStartDate,
    endDate,
    setEndDate,
  };
};

/**
 * This is a shorthand for the type of the parameter passed to a date setter.
 */
export type DateActionParam =
  | Date
  | SetStateAction<Date | undefined>
  | undefined;
